export function getDisplayName(user, fallback = "") {
  if (!user) return fallback;
  const candidates = [
    user.display_name,
    user.displayName,
    user.first_name,
    user.firstName,
    user.last_name,
    user.lastName,
  ];
  for (const c of candidates) {
    if (typeof c === "string" && c.trim()) return c.trim();
  }
  return fallback;
}

export function getFullName(user, fallback = "") {
  if (!user) return fallback;
  const first = (user.first_name || user.firstName || "").trim();
  const last = (user.last_name || user.lastName || "").trim();
  const full = [first, last].filter(Boolean).join(" ");
  return full || getDisplayName(user, fallback);
}
